import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BillingRequestService {

  getRequestTypeList(policy) {
    const requestTypeList = ["Refunds"];
    if (policy.policyType.includes('AUTO')) {
      requestTypeList.push("Discounts");
    }
    requestTypeList.push("Other request");
    return requestTypeList;
  }
  setPolicyTypeImage(policyType) {
    let policyTypeImg;
    if (policyType.includes('AUTO')) {
      policyTypeImg = "./assets/img/images/icon-car-billing-question.svg";
    } else if (policyType.includes('HOME')) {
      policyTypeImg = "./assets/img/images/icon-home-billing-question.svg";
    } else {
      policyTypeImg = "./assets/img/images/icon-umbrella-billing-question.svg";
    }
    return policyTypeImg;
  }

  getNonMAGWInputs() {
    return [
      "Question about my bill",
      "Autopay question",
      "Non Pay cancellation question",
      "Paperless question",
      "Premium question",
      "General billing question",
      "Issues with online account"
    ];
  }

  getMAInputs() {
    return [
      "Question about my bill",
      "Autopay question",
      "Non pay cancellation question",
      "Paperless question",
      "Premium question",
      "General billing question",
      "Cancellations",
      "Issues with online account"
    ];
  }
  getAcmicInputs() {
    return [
      "Question about my bill",
      "Autopay question",
      "Non pay cancellation question",
      "Paperless question",
      "Premium question",
      "General billing question",
      "Fee wavier question",
      "Issues with online account"
    ];
  };

  dateValidator(year, month, day) {
    const noOfDaysInMonth = new Date(year, month, 0).getDate();
    if (day <= noOfDaysInMonth) return true
    else return false
  }
  months(){
    return[
      {
        id:0,
        name:'MM',
        disabled:true
      },
      {
        id:1,
        name:'01',
        disabled:false
      },
      {
        id:2,
        name:'02',
        disabled:false
      },
      {
        id:3,
        name:'03',
        disabled:false
      },{
        id:4,
        name:'04',
        disabled:false
      },{
        id:5,
        name:'05',
        disabled:false
      },{
        id:6,
        name:'06',
        disabled:false
      },{
        id:7,
        name:'07',
        disabled:false
      },{
        id:8,
        name:'08',
        disabled:false
      },{
        id:9,
        name:'09',
        disabled:false
      },{
        id:10,
        name:'10',
        disabled:false
      },{
        id:11,
        name:'11',
        disabled:false
      },
      {
        id:12,
        name:'12',
        disabled:false
      },
    ]

  }
  days() {
    return[
      {
      id: 0,
      name: 'DD',
      disabled: true,
    }, {
      id: 1,
      name: '01',
      disabled: false,
    },
    {
      id: 2,
      name: '02',
      disabled: false,
    },
    {
      id: 3,
      name: '03',
      disabled: false,
    },{
      id: 4,
      name: '04',
      disabled: false,
    },
    {
      id: 5,
      name: '05',
      disabled: false,
    },
    {
      id: 6,
      name: '06',
      disabled: false,
    },
    {
      id: 7,
      name: '07',
      disabled: false,
    },
    {
      id: 8,
      name: '08',
      disabled: false,
    },{
      id: 9,
      name: '09',
      disabled: false,
    },{
      id: 0,
      name: '10',
      disabled: false,
    },{
      id: 11,
      name: '11',
      disabled: false,
    },{
      id: 12,
      name: '12',
      disabled: false,
    },{
      id: 13,
      name: '13',
      disabled: false,
    },{
      id: 14,
      name: '14',
      disabled: false,
    },{
      id: 15,
      name: '15',
      disabled: false,
    },{
      id: 16,
      name: '16',
      disabled: false,
    },{
      id: 17,
      name: '17',
      disabled: false,
    },{
      id: 18,
      name: '18',
      disabled: false,
    },{
      id: 19,
      name: '19',
      disabled: false,
    },{
      id: 20,
      name: '20',
      disabled: false,
    },{
      id: 21,
      name: '21',
      disabled: false,
    },{
      id: 22,
      name: '22',
      disabled: false,
    },{
      id: 23,
      name: '23',
      disabled: false,
    },{
      id: 24,
      name: '24',
      disabled: false,
    },{
      id: 25,
      name: '25',
      disabled: false,
    },{
      id: 26,
      name: '26',
      disabled: false,
    },{
      id: 27,
      name: '27',
      disabled: false,
    },{
      id: 28,
      name: '28',
      disabled: false,
    },{
      id: 29,
      name: '29',
      disabled: false,
    },{
      id: 30,
      name: '30',
      disabled: false,
    },{
      id: 31,
      name: '31',
      disabled: false,
    }]
  }
  wdayss(){
    return [
      {
        id: 1,
        name: 'DD',
			  disabled: true,
      },
      {
        id: 2,
        name: '1',
			  disabled: false,
      },
      {
        id: 3,
        name: '2',
			  disabled: false,
      },
    ]
  }

}
